import PropTypes from 'prop-types';
import React from 'react';

class LabelErrorDirectly extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.any
    };
  }

  render() {
    return <div className="alert-title">{this.props.children}</div>;
  }
}

export default LabelErrorDirectly;
